import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IRingsFilter } from '@/models/store/filter-data/rings-filter.model';
import { ICenteringRing } from '@/models/store/rings/centering-ring.model';
import { IRingsFilterData } from '@/models/store/rings/rings-filter-data.model';
import { IRingsState } from '@/models/store/rings/rings-state.model';
import { Module } from 'vuex';

export const ringsModule: Module<IRingsState, unknown> = {
    state: {
        centeringRings: [],
        ringsFilterData: { external: [], internal: [] },
    },

    actions: {
        fetchRings: async (
            { commit },
            payload: { pageNumber: number; count: number; ringsFilter: IRingsFilter },
        ): Promise<void> => {
            const params = new URLSearchParams();
            params.append('pageNumber', `${payload.pageNumber}`);
            params.append('count', `${payload.count}`);
            if (payload.ringsFilter.external)
                params.append('external', payload.ringsFilter.external);
            if (payload.ringsFilter.internal)
                params.append('internal', payload.ringsFilter.internal);
            if (payload.ringsFilter.rest) params.append('rest', payload.ringsFilter.rest);
            if (payload.ringsFilter.typeName)
                params.append('typeName', payload.ringsFilter.typeName);

            const response = await fetch(`${environment.baseUrl}/api/centering-rings?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const ringsData = await response.json();
            commit('setPaginationLength', ringsData.length);
            commit('setRings', ringsData.data);
        },

        fetchRingsFilterData: async ({ commit }) => {
            const response = await fetch(`${environment.baseUrl}/api/helper-centerings`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const filterData = (await response.json()).data;
            commit('setRingsFilterData', filterData);
        },
    },

    mutations: {
        setRings: (store, payload: ICenteringRing[]): void => {
            store.centeringRings = [...payload];
        },
        setRingsFilterData: (store, payload: IRingsFilterData): void => {
            store.ringsFilterData = { ...payload };
        },
    },

    getters: {
        getRings: (store) => store.centeringRings,
        getRingsFilterData: (store) => store.ringsFilterData,
    },
};
